(function () {
  'use strict';

  const DAYS_PER_BOX = 30;

  const state = {
    mode: 'sub',
    submitting: false,
    subBoxes: null,
    otBoxes: null,
    sellingPlanId: null
  };

  const external = {
    form: null,
    submitButton: null,
    sealElement: null,
    bundlerElement: null
  };

  const productData = {
    variantId: null,
    basePrice: 0,
    compareAtPrice: 0,
    plans: [],
    bundleTiers: {},
    bundleTierOrder: []
  };

  const dom = {};

  function cacheDomReferences() {
    dom.root        = document.getElementById('tmw-purchase-widget');
    dom.boxesBody   = document.getElementById('tmw-boxes-body');
    dom.subBody     = document.getElementById('tmw-subscription-body');
    dom.subBlock    = document.getElementById('tmw-sub-block');
    dom.otBlock     = document.getElementById('tmw-ot-block');
    dom.subBadge    = document.getElementById('tmw-sub-badge');
    dom.otBadge     = document.getElementById('tmw-ot-badge');
    dom.subPrice    = document.getElementById('tmw-sub-price');
    dom.subDay      = document.getElementById('tmw-sub-day');
    dom.otPrice     = document.getElementById('tmw-ot-price');
    dom.otDay       = document.getElementById('tmw-ot-day');
    dom.boxesLabel  = document.getElementById('tmw-boxes-label');
    dom.boxes       = document.getElementById('tmw-boxes');
    dom.freqWrapper = document.getElementById('tmw-freq-wrapper');
    dom.freqSelect  = document.getElementById('tmw-sub-freq');
    dom.freqUnit    = document.getElementById('tmw-freq-unit');
    dom.freqHint    = document.getElementById('tmw-freq-hint');
    dom.savingsNote = document.getElementById('tmw-savings-note');
    dom.savingsText = document.getElementById('tmw-savings-text');
    dom.addButton   = document.getElementById('tmw-add-btn');
    dom.cartError = document.createElement('p');
    dom.cartError.className = 'tmw-cart-error';
    dom.cartError.setAttribute('role', 'alert');
    dom.cartError.hidden = true;
    if (dom.addButton) dom.addButton.after(dom.cartError);
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '$0.00';
    return '$' + (cents / 100).toFixed(2);
  }

  function boxLabel(count) {
    return count === 1 ? 'box' : 'boxes';
  }

  function formatPercent(value) {
    return Math.round(value) + '% off';
  }

  function findProductForm() {
    const widget = document.getElementById('tmw-purchase-widget');
    const section = widget ? widget.closest('section') : null;
    let form = null;
    if (section) form = section.querySelector('form[action*="/cart/add"]');
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    return form || null;
  }

  function findSealElement(form) {
    if (!form) return null;
    const withData = form.querySelector('.sealsubs-target-element[data-product]');
    return withData || form.querySelector('.sealsubs-target-element');
  }

  function findBundlerElement(form) {
    if (!form) return null;
    return form.querySelector('.bundler-volume-target-element');
  }

  function parseShopifyData() {
    const dataElement = document.getElementById('tmw-product-data');
    if (!dataElement) return false;

    let data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (e) {
      return false;
    }

    if (data.variantId) productData.variantId = data.variantId;
    productData.basePrice = data.basePrice || 0;
    productData.compareAtPrice = data.compareAtPrice || data.basePrice || 0;

    if (!data.plans || !data.plans.length) return false;

    productData.plans = data.plans.map((plan) => {
      const price = plan.price;
      const compareAt = plan.compareAtPrice || productData.compareAtPrice || price;
      return {
        planId: String(plan.planId),
        label: plan.label || plan.name || ('Plan ' + plan.planId),
        planName: plan.name || '',
        price: price,
        compareAt: compareAt,
        discountPct: compareAt > 0 ? ((compareAt - price) / compareAt) * 100 : 0
      };
    });

    return productData.plans.length > 0;
  }

  function parseBundlerTiers(bundlerElement) {
    productData.bundleTiers = {};
    productData.bundleTierOrder = [];
    if (!bundlerElement) return false;

    bundlerElement.querySelectorAll('.bndlr-radio-container').forEach((container) => {
      const input = container.querySelector(
        'input[type="radio"][name="bundle_quantity"]'
      );
      if (!input) return;
      const quantity = parseInt(input.value, 10);
      if (!quantity) return;

      const priceElement    = container.querySelector('.bndlr-discounted-price');
      const originalElement = container.querySelector('.bndlr-original-price');
      const savingsElement  = container.querySelector('.bndlr-savings-text');

      const price = priceElement
        ? parseInt(priceElement.getAttribute('data-currentprice') || '0', 10)
        : 0;
      const originalPrice = originalElement
        ? parseInt(originalElement.getAttribute('data-currentprice') || '0', 10)
        : null;
      const discountPct = (originalPrice && originalPrice > price)
        ? (originalPrice - price) / originalPrice
        : 0;

      productData.bundleTiers[quantity] = {
        price: price,
        originalPrice: originalPrice,
        discountPct: discountPct,
        savingsText: savingsElement ? savingsElement.textContent.trim() : ''
      };
      productData.bundleTierOrder.push(quantity);
    });

    return productData.bundleTierOrder.length > 0;
  }

  function buildBoxButtons() {
    if (!productData.bundleTierOrder.length) {
      productData.bundleTiers = {
        1: { price: productData.basePrice, originalPrice: null, discountPct: 0, savingsText: '' }
      };
      productData.bundleTierOrder = [1];
    }

    dom.boxes.innerHTML = '';
    productData.bundleTierOrder.forEach((quantity) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tmw-box-btn';
      button.setAttribute('data-val', String(quantity));
      button.innerHTML =
        `<span class="tmw-box-count">${quantity}<span class="tmw-box-unit">${boxLabel(quantity)}</span></span>` +
        `<span class="tmw-box-sublabel">${quantity * DAYS_PER_BOX}-day supply</span>` +
        `<span class="tmw-box-save"></span>`;
      dom.boxes.appendChild(button);
    });
  }

  /* Seal returns a bare unit ("month") for the 1-interval plan, so the
     count is added back to keep every option reading the same way. */
  function formatFrequencyLabel(label) {
    const text = String(label || '').trim();
    return /^\d/.test(text) ? text : '1 ' + text;
  }

  function buildFrequencyOptions() {
    dom.freqSelect.innerHTML = '';
    if (!productData.plans.length) {
      if (dom.subBlock) dom.subBlock.style.display = 'none';
      return;
    }
    /* Empty-valued first option: the customer must pick a cadence
       explicitly, so there is no cadence chosen by accident. */
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select delivery frequency';
    dom.freqSelect.appendChild(placeholder);

    productData.plans.forEach((plan) => {
      const option = document.createElement('option');
      option.value = plan.planId;
      option.textContent = formatFrequencyLabel(plan.label);
      dom.freqSelect.appendChild(option);
    });
    if (dom.freqHint) dom.freqHint.textContent = '';
    if (dom.freqUnit) dom.freqUnit.textContent = '';
  }

  function getCurrentPlan() {
    if (!state.sellingPlanId) return null;
    return productData.plans.find((plan) => plan.planId === state.sellingPlanId) || null;
  }

  function applyBundlerSelection(quantity) {
    if (!external.bundlerElement || !quantity) return;
    const radio = external.bundlerElement.querySelector(
      `input[type="radio"][name="bundle_quantity"][value="${quantity}"]`
    );
    if (!radio || radio.checked) return;
    radio.click();
  }

  function applySealSelection() {
    if (!external.sealElement) return;

    if (state.mode === 'sub') {
      const subRadio = external.sealElement.querySelector(
        'input[type="radio"][data-type="subscription"]'
      );
      if (subRadio && !subRadio.checked) subRadio.click();

      if (state.sellingPlanId) {
        const intervalSelect = external.sealElement.querySelector(
          'select[name="subs_interval"]'
        );
        if (intervalSelect && intervalSelect.value !== state.sellingPlanId) {
          intervalSelect.value = state.sellingPlanId;
          intervalSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else {
      const oneTimeRadio = external.sealElement.querySelector(
        'input[type="radio"][data-type="one_time"]'
      );
      if (oneTimeRadio && !oneTimeRadio.checked) oneTimeRadio.click();
    }
  }

  function syncUnderlyingForm() {
    const quantity = state.mode === 'sub' ? state.subBoxes : state.otBoxes;
    applyBundlerSelection(quantity);
    applySealSelection();
  }

  function enforceFormState() {
    if (!external.form) return;

    const quantity = state.mode === 'sub' ? state.subBoxes : state.otBoxes;

    if (productData.variantId) {
      external.form.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = productData.variantId;
        input.disabled = false;
      });
    }

    if (external.bundlerElement && quantity) {
      external.bundlerElement
        .querySelectorAll('input[name="bundle_quantity"]')
        .forEach((radio) => {
          radio.checked = (parseInt(radio.value, 10) === quantity);
        });
    }

    const sellingPlanInputs = external.form.querySelectorAll(
      'input[name="selling_plan"]'
    );
    if (sellingPlanInputs.length) {
      sellingPlanInputs.forEach((input) => {
        input.value = state.mode === 'sub' ? (state.sellingPlanId || '') : '';
        input.disabled = false;
      });
    } else if (state.mode === 'sub' && state.sellingPlanId) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = state.sellingPlanId;
      external.form.appendChild(input);
    }
  }

  function attachSubmitGuard() {
    if (!external.form) return;
    external.form.addEventListener('submit', (event) => {
      /* Catches any submit path, not just our own button. */
      if (needsFrequency()) {
        event.preventDefault();
        event.stopPropagation();
        flagMissingFrequency();
        return;
      }
      enforceFormState();
    }, true);
  }

  function selectMode(mode) {
    state.mode = mode;
    dom.subBlock.classList.toggle('tmw-active', mode === 'sub');
    dom.otBlock.classList.toggle('tmw-active',  mode === 'ot');
    dom.otBadge.classList.toggle('tmw-badge-inactive',  mode !== 'ot');
    dom.subBadge.classList.toggle('tmw-badge-inactive', mode !== 'sub');
    syncUnderlyingForm();
    render();
  }

  function selectBoxes(mode, quantity) {
    state.subBoxes = quantity;
    state.otBoxes = quantity;
    syncUnderlyingForm();
    render();
  }

  function onFrequencyChange() {
    state.sellingPlanId = dom.freqSelect.value || null;
    dom.freqWrapper.classList.remove('tmw-pulse');
    syncUnderlyingForm();
    render();
  }

  /* True while the customer is on the subscription option but has not
     picked a cadence yet — blocks add-to-cart. */
  function needsFrequency() {
    return state.mode === 'sub' && productData.plans.length > 0 && !getCurrentPlan();
  }

  /* Draws attention to the untouched dropdown after a blocked submit. */
  function flagMissingFrequency() {
    dom.freqWrapper.classList.remove('tmw-pulse');
    void dom.freqWrapper.offsetWidth; /* restart the animation */
    dom.freqWrapper.classList.add('tmw-pulse');
    if (dom.freqWrapper.scrollIntoView) {
      dom.freqWrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    dom.freqSelect.focus();
  }

  function subscriptionPerBoxPrice(plan, quantity) {
    if (!plan) return 0;
    const tier = productData.bundleTiers[quantity];
    const bundlerPct = tier ? tier.discountPct : 0;
    return Math.ceil(plan.price * (1 - bundlerPct));
  }

  /* The plan the subscription block prices against. Until a cadence is
     chosen we preview the cheapest one, so the block is never blank. */
  function displayPlan() {
    const chosen = getCurrentPlan();
    if (chosen) return chosen;
    if (!productData.plans.length) return null;
    return productData.plans.reduce(
      (best, plan) => (plan.price < best.price ? plan : best)
    );
  }

  /* When every cadence costs the same, a previewed price needs no
     "From" qualifier — it is already the price they will pay. */
  function plansSharePrice() {
    return productData.plans.every(
      (plan) => plan.price === productData.plans[0].price
    );
  }

  /* Bundle badges show only the extra quantity discount in either mode.
     The subscription badge shows total savings, including the selected bundle. */
  function boxSavingsPct(quantity) {
    const tier = productData.bundleTiers[quantity];
    return quantity > 1 && tier ? tier.discountPct * 100 : 0;
  }

  function render() {
    const plan = displayPlan();
    const awaitingFrequency = needsFrequency();
    const activeMode = state.mode;
    const activeBoxes = (activeMode === 'sub' ? state.subBoxes : state.otBoxes) || 1;
    const showSubscriptionUi = activeMode === 'sub' && productData.plans.length > 0;

    dom.boxesLabel.textContent = 'Choose Your Bundle';
    dom.subBody.classList.toggle('tmw-hidden', !showSubscriptionUi);

    dom.freqWrapper.classList.toggle('tmw-settled', !awaitingFrequency);
    dom.savingsNote.classList.toggle('tmw-hidden', awaitingFrequency);

    dom.boxes.querySelectorAll('.tmw-box-btn').forEach((button) => {
      const quantity = parseInt(button.dataset.val, 10);
      button.classList.toggle('tmw-selected', quantity === activeBoxes);

      const saveElement = button.querySelector('.tmw-box-save');
      if (saveElement) {
        const pct = boxSavingsPct(quantity);
        saveElement.textContent = pct >= 1 ? 'Extra ' + Math.round(pct) + '% off' : '';
      }
    });

    if (plan) {
      const subPerBox = subscriptionPerBoxPrice(plan, state.subBoxes);
      const qualifier = (awaitingFrequency && !plansSharePrice()) ? 'From ' : '';
      dom.subPrice.innerHTML =
        qualifier + formatMoney(subPerBox) + '<span class="tmw-price-unit">/box</span>';
      dom.subDay.textContent = formatMoney(subPerBox / DAYS_PER_BOX) + '/day';

      const compareAt = plan.compareAt || productData.compareAtPrice;
      const combinedPct = compareAt > 0
        ? ((compareAt - subPerBox) / compareAt) * 100
        : 0;
      dom.subBadge.textContent = combinedPct > 0
        ? formatPercent(combinedPct)
        : 'Subscribe';
    }

    const otTier = productData.bundleTiers[state.otBoxes];
    if (otTier) {
      const otPerBox = Math.ceil(productData.basePrice * (1 - otTier.discountPct));
      dom.otPrice.innerHTML =
        formatMoney(otPerBox) + '<span class="tmw-price-unit">/box</span>';
      dom.otDay.textContent = formatMoney(otPerBox / DAYS_PER_BOX) + '/day';

      if (otTier.savingsText) {
        dom.otBadge.textContent = otTier.savingsText;
      } else if (otTier.discountPct > 0) {
        dom.otBadge.textContent = formatPercent(otTier.discountPct * 100);
      } else {
        dom.otBadge.textContent = 'Base price';
      }
    }

    let activePerBox, activeTotal;
    if (state.mode === 'sub' && plan) {
      activePerBox = subscriptionPerBoxPrice(plan, activeBoxes);
      activeTotal = activePerBox * activeBoxes;
    } else if (otTier) {
      activePerBox = Math.ceil(productData.basePrice * (1 - otTier.discountPct));
      activeTotal = activePerBox * activeBoxes;
    } else {
      activeTotal = productData.basePrice;
      activePerBox = productData.basePrice;
    }

    /* Left clickable on purpose: a truly disabled button swallows the
       click, and the customer gets no hint about what is missing. */
    dom.addButton.disabled = state.submitting;
    dom.addButton.setAttribute('aria-busy', String(state.submitting));
    dom.addButton.classList.toggle('tmw-disabled', awaitingFrequency || state.submitting);
    dom.addButton.setAttribute('aria-disabled', String(awaitingFrequency || state.submitting));
    dom.addButton.textContent = state.submitting ? 'Opening checkout…' : awaitingFrequency
      ? 'Select delivery frequency'
      : 'Buy Now — ' + formatMoney(activeTotal);

    if (plan) {
      const subBoxes = state.subBoxes || 1;
      const subPerBox = subscriptionPerBoxPrice(plan, subBoxes);
      dom.savingsText.textContent =
        `${subBoxes} ${boxLabel(subBoxes)} every ${plan.label} — ${formatMoney(subPerBox * subBoxes)}/shipment`;
    }
  }

  function addToCart() {
    if (state.submitting || external.submitButton?.getAttribute('aria-disabled') === 'true') return;
    if (needsFrequency()) {
      flagMissingFrequency();
      return;
    }
    syncUnderlyingForm();
    enforceFormState();
    if (!external.form || !external.submitButton) return;
    external.submitButton.click();
  }

  function wireEvents() {
    external.form.dataset.tmwBuyNow = 'true';
    external.form.addEventListener('tmw:cart-pending', (event) => {
      state.submitting = event.detail.pending;
      render();
    });
    external.form.addEventListener('tmw:cart-error', (event) => {
      dom.cartError.textContent = event.detail.message;
      dom.cartError.hidden = !event.detail.message;
    });
    dom.subBlock.addEventListener('click', () => {
      selectMode('sub');
    });
    dom.otBlock.addEventListener('click', () => {
      selectMode('ot');
    });

    dom.boxes.addEventListener('click', (event) => {
      const button = event.target.closest('.tmw-box-btn');
      if (!button) return;
      selectBoxes(state.mode, parseInt(button.dataset.val, 10));
    });

    dom.freqSelect.addEventListener('change', onFrequencyChange);
    dom.addButton.addEventListener('click', addToCart);
  }

  function chooseInitialState() {
    const tiers = productData.bundleTierOrder;
    const largestTier = tiers.length ? tiers[tiers.length - 1] : 1;
    state.subBoxes = largestTier;
    state.otBoxes  = largestTier;

    if (productData.plans.length) {
      state.sellingPlanId = null;
      dom.freqSelect.value = '';
    } else {
      state.mode = 'ot';
    }
  }

  function markPreselectedButtons() {
    dom.subBlock.classList.toggle('tmw-active', state.mode === 'sub');
    dom.otBlock.classList.toggle('tmw-active',  state.mode === 'ot');
    dom.otBadge.classList.toggle('tmw-badge-inactive',  state.mode !== 'ot');
    dom.subBadge.classList.toggle('tmw-badge-inactive', state.mode !== 'sub');
  }

  function resolveExternalElements() {
    external.form = findProductForm();
    external.submitButton = external.form &&
      external.form.querySelector('button[type="submit"], [type="submit"]');
    external.sealElement    = findSealElement(external.form);
    external.bundlerElement = findBundlerElement(external.form);
  }

  function observeUntil(target, predicate) {
    return new Promise((resolve) => {
      if (predicate()) { resolve(); return; }
      const observer = new MutationObserver(() => {
        if (predicate()) {
          observer.disconnect();
          resolve();
        }
      });
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function rebuildBundlerTiers() {
    const previousSubBoxes = state.subBoxes;
    const previousOtBoxes  = state.otBoxes;

    parseBundlerTiers(external.bundlerElement);
    buildBoxButtons();

    const tiers = productData.bundleTierOrder;
    const largestTier = tiers.length ? tiers[tiers.length - 1] : 1;
    state.subBoxes = tiers.indexOf(previousSubBoxes) >= 0 ? previousSubBoxes : largestTier;
    state.otBoxes  = tiers.indexOf(previousOtBoxes)  >= 0 ? previousOtBoxes  : largestTier;

    markPreselectedButtons();
    syncUnderlyingForm();
    render();
  }

  function attachBundlerObserver() {
    if (typeof MutationObserver === 'undefined') return;
    if (!external.bundlerElement) return;
    if (external.bundlerElement.hasAttribute('data-tmw-observed')) return;
    external.bundlerElement.setAttribute('data-tmw-observed', '1');

    const observer = new MutationObserver(() => {
      const radios = external.bundlerElement.querySelectorAll(
        'input[name="bundle_quantity"]'
      );
      if (radios.length !== productData.bundleTierOrder.length) {
        rebuildBundlerTiers();
      }
    });
    observer.observe(external.bundlerElement, { childList: true, subtree: true });
  }

  function watchForLateApps() {
    if (!external.form || typeof MutationObserver === 'undefined') return;
    if (external.bundlerElement && external.sealElement) return;

    const observer = new MutationObserver(() => {
      if (!external.bundlerElement) {
        const bundler = findBundlerElement(external.form);
        if (bundler) {
          external.bundlerElement = bundler;
          attachBundlerObserver();
          if (parseBundlerTiers(bundler)) rebuildBundlerTiers();
        }
      }
      if (!external.sealElement) {
        external.sealElement = findSealElement(external.form);
      }
      if (external.bundlerElement && external.sealElement) {
        observer.disconnect();
      }
    });
    observer.observe(external.form, { childList: true, subtree: true });
  }

  async function init() {
    cacheDomReferences();
    if (!dom.root) return;

    const hasPlans = parseShopifyData();

    await observeUntil(document.documentElement, () => {
      resolveExternalElements();
      return !!external.form && !!external.submitButton;
    });

    const hasBundler = parseBundlerTiers(external.bundlerElement);

    if (!hasPlans && !hasBundler) {
      if (dom.root) dom.root.style.display = 'none';
      return;
    }

    buildBoxButtons();
    buildFrequencyOptions();
    chooseInitialState();
    markPreselectedButtons();
    wireEvents();
    attachSubmitGuard();
    attachBundlerObserver();
    watchForLateApps();
    syncUnderlyingForm();
    render();

    dom.root.classList.add('tmw-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
